import React from "react";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import Input from "../../../../../../components/form/Input";
import IcoInput from "../../../../../../components/form/IcoInput";
import CroField from "../../../generalForm/CroField";
import CroCountry from "../../../generalForm/CroCountry";
import CroMunicipality from "../../../generalForm/CroMunicipality";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import { fieldsRemove } from "../../../../CroUtils";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { ItemNumber, useItemHandlers } from "./itemRenumber";

export default ({
  fields,
  disabled,
  noPublicLogged,
  t,
  defaultCountry,
  isLogged,
  onICOChange,
  aresErrors,
  versionChangedClass
}) => {
  const { addItem, removeItem } = useItemHandlers(fields);
  return (
    <div className="cro-array-container">
      {fields.map((item, index) => (
        <div key={index} className={`cro-array-item ${versionChangedClass ? versionChangedClass(item) : ''}`}>
          <ItemNumber index={index} />
          {!disabled && fields.length > 1 && (
              <CroRemoveButton onClick={() => removeItem(index)} />
          )}
          <div className="cro-array-item-content">
            <div className="statementForm__arrayGrid">
              <div>
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.identificationNumber`) : ""}
                  title="IČO"
                  name={`${item}.legalPerson.identificationNumber`}
                  component={IcoInput}
                  disabled={disabled}
                  validate={[V.required, V.isNumeric]}
                  helpEnum={H[`${t}OM_IDENTIFICATION_NUMBER`].r}
                  onICOChange={(val) => onICOChange && onICOChange(index, val)}
                />
                {aresErrors && aresErrors[index] && (
                  <span className="cro-ares-error">{aresErrors[index]}</span>
                )}
              </div>

              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                title="Druh orgánu"
                name={`${item}.type`}
                component={AutoComplete}
                fullWidth
                disabled={disabled}
                url="/api/ciselniky/druhy-organizace"
                validate={[V.required, V.isDictionary]}
                helpEnum={H[`${t}OM_TYPE`].r}
              />

              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.name`) : ""}
                title="Obchodní firma/název"
                name={`${item}.legalPerson.name`}
                component={Input}
                disabled={disabled}
                validate={[V.required]}
                helpEnum={H[`${t}OM_NAME`].r}
              />

              <p className="statementForm__arrayLabel">
                Sídlo právnické osoby{" "}
                <Help helpEnum={H[`${t}OM_ADDRESS`].r} disabled={disabled} />
              </p>

              <CroCountry
                className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.country`) : ""}
                title="Stát"
                name={`${item}.legalPerson.address`}
                disabled={disabled}
                form="statementForm"
                validate={[V.required]}
                defaultCountry={defaultCountry}
              />
              <CroMunicipality
                className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.municipality`) : ""}
                title="Obec"
                name={`${item}.legalPerson.address`}
                disabled={disabled}
                form="statementForm"
                validate={[V.required]}
              />

              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.street`) : ""}
                title="Ulice"
                name={`${item}.legalPerson.address.street`}
                component={Input}
                disabled={disabled}
                validate={[V.required]}
              />
              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.orientationNumber`) : ""}
                title="Č.p./Č.o."
                name={`${item}.legalPerson.address.orientationNumber`}
                component={Input}
                disabled={disabled}
                validate={[V.required]}
                helpEnum={H.HOUSE_NUMBER.r}
              />

              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.legalPerson.address.zip`) : ""}
                title="PSČ"
                name={`${item}.legalPerson.address.zip`}
                component={Input}
                disabled={disabled}
                validate={[V.required]}
              />

              {noPublicLogged && (
                <div className="statementForm__arrayFull">
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                    title="Poznámka"
                    name={`${item}.note`}
                    component={Input}
                    disabled={disabled}
                    multiline
                    helpEnum={H[`${t}OM_NOTE`].r}
                    maxlen={1000}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {!disabled && (
        <div className="cro-array-add">
          <CroAddButton onClick={() => addItem()} />
          <Help helpEnum={H.ADD_REMOVE_OM.r} />
        </div>
      )}
    </div>
  );
};
